<template>
  <CockpitDialog :title="title" @close="$emit('close')" class="fixed left-500px top-140px">
    <div class="flex justify-between">
      <tableButtonGroup v-model="tabActive" :list="tabSystemList" />
      <el-button
        class="!h-26px !text-white"
        type="primary"
        size="mini"
        :loading="btnLoading"
        @click.stop="getApInfoAndEnterNetWork"
        >查看详情</el-button
      >
    </div>
    <el-row class="h-150px mt-10px flex justify-center">
      <el-col :span="14" class="grid grid-cols-2 gap-2 pr-20px">
        <div class="flex" v-for="[key, value] in leftDataMap" :key="key">
          <span class="flex justify-end items-center w-110px mr-10px whitespace-nowrap text-[#fff]">{{ key }}</span>
          <el-tooltip class="flex items-center" effect="light" :content="sensorDetailData[value]" :disabled="!sensorDetailData[value]" placement="top">
            <!-- <div class="truncate ">{{ sensorDetailData[value] }}</div> -->
            <el-input
            v-model="sensorDetailData[value]"
            size="small"
            class="mr-10px !w-200px diy-input-style"
            :disabled="true"
          ></el-input>

          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="10" class="h-full grid grid-cols-2 gap-4">
        <div
          class="bg-diy text-center flex flex-col justify-center"
          v-for="[key, value] in rightDataMap"
          :key="key"
        >
          <p class="text-hex-44f1ff font-bold">{{ rightData[value] }}</p>
          <p class="text-[#fff]">{{ key }}</p>
        </div>
      </el-col>
    </el-row>
    <CategoryTitle title="测点名称" class="mt-10px mb-5px" />
    <el-row class="h-[calc(100%-209px)] flex justify-center">
      <v-chart
        class="w-full h-full"
        :options="detailOptions"
        :autoresize="true"
        :init-options="{ devicePixelRatio: 2 }"
      ></v-chart>
    </el-row>
  </CockpitDialog>
</template>

<script>
import { BoxMeasuringPointApi, WizapListingApi, WizboxListingApi } from '@wiz-api/data-box'
import { IotApi } from '@wiz-api/measuring-point-management'
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import dayjs from 'dayjs'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import axios from 'axios'

const boxMeasuringPointApi = new BoxMeasuringPointApi()
const wizapListingApi = new WizapListingApi()
const wizboxListingApi = new WizboxListingApi()
const iotApi = new IotApi()
export default {
  name: 'DialogViewSensorDetail',
  components: { CockpitDialog, tableButtonGroup, CategoryTitle },
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '查看详情',
      tabSystemList: [],
      tabActive: '',
      sensorDetailData: {
        boxName: '',
        installationLocaltion: '',
        installationTime: '',
        responsiblePerson: '',
        dismantleTime: '',
        dismantlePerson: '',
      },
      startOfDayTimestamp: 0,
      endOfDayTimestamp: 0,
      pointIds: [],
      pointNames: [],
      // 左侧数据
      leftDataMap: new Map([
        ['传感器型号', 'sensorTypeName'],
        ['传感器编号', 'boxIdentifier'],
        ['最新状态', 'boxStatusName'],
        ['设备kks编码', 'equipCode'],
        ['负责人', 'responsiblePerson'],
        ['安装位置', 'installationLocaltion'],
      ]),
      // 右侧数据
      rightDataMap: new Map([
        ['监测时长', 'monitorTimeLength'],
        // ['近30天预警次数', 'alarmCount'],
        ['剩余电量（%）', 'electricity'],
        ['包含测点（个）', 'pointListLength'],
      ]),
      rightData: {
        monitorTimeLength: '- 天',
        alarmCount: '- 次',
        electricity: '-',
        pointListLength: '-',
      },
      detailOptions: {
        color: ['#3CD495', '#5FD5EC', '#2276FC'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: 12 },
          confine: true,
          borderWidth: 1,
          borderColor: '#35d0dd',
          backgroundColor: 'rgba(17,83,71,0.8)',
        },
        legend: {
          show: false,
          data: ['无测点'],
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          top: '15%',
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            color: '#fff',
            // interval: 0,
            // rotate: 45,
            // formatter: (value, index) => {
            //   if (index % 3 === 0) {
            //     return value
            //   }
            //   return ''
            // },
          },
          axisTick: {
            alignWithLabel: true,
            interval: 0,
            // show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: {
          type: 'value', // log
          axisLabel: {
            color: '#fff',
          },
          splitLine: {
            lineStyle: {
              color: '#ffffff22',
            },
          },
        },
        series: [
          {
            name: '无测点',
            data: [],
            type: 'line',
          },
        ],
      },
      // 按钮loading状态
      btnLoading: false,
    }
  },
  computed: {
    gatewayConfig() {
      return Wiz.dynamicModules.instances['iot-box'].config || {}
    },
  },
  watch: {},
  created() {
    this.getSensorDetail()
  },
  methods: {
    // 查看详情按钮
    async getApInfoAndEnterNetWork() {
      const params = {
        apIdentifier: this.sensorDetailData.apIdentifier,
      }
      const [err, res] = await wizapListingApi.findApAndSensorCountUsingGET(params)
      if (!err && res.data.length > 0) {
        this.enterNetWork(res.data[0])
      }
    },
    // 进入网关
    async enterNetWork(data) {
      this.btnLoading = true
      const [err, res] = await wizapListingApi.findApByTypeUsingGET(data.apType, data.apIdentifier)
      if (err) {
        this.$message.error('进入网关失败')
        this.btnLoading = false
        return
      }
      if (!res.data.ethernetIp) {
        this.$message.warning('未获取到网关IP地址')
        this.btnLoading = false
        return
      }
      if (!this.gatewayConfig.gatewayPort) {
        this.$message.warning('未配置网关端口')
        this.btnLoading = false
        return
      }
      const gatewayUrl = `http://${res.data.ethernetIp}:${this.gatewayConfig.gatewayPort}`
      // 进入网关免登录
      axios({
        method: 'POST',
        url: `${gatewayUrl}/moduleapi/api/login`,
        data: {
          user: this.gatewayConfig.gatewayUsername,
          password: this.gatewayConfig.gatewayPassword,
        },
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        timeout: 5000,
      }).finally(() => {
        this.btnLoading = false
        window.open(gatewayUrl, '_blank')
      })
    },
    async getSensorDetail() {
      this.sensorDetailData = this.detailData
      // 通过boxIdentifier获取测点列表
      const [err, res] = await boxMeasuringPointApi.findAllUsingGET({
        boxName: this.sensorDetailData.boxIdentifier,
      })
      if (!err) {
        this.sensorDetailData.pointList = res.data || []
        this.getRightData()
        this.pointIds = this.sensorDetailData.pointList.map((item) => {
          return item.pointId.toString()
        })
        this.pointNames = this.sensorDetailData.pointList.map((item) => {
          return item.pointName
        })
      } else {
        console.error('获取测点列表失败:', err)
      }
      // 获取图表数据
      this.getChartData(this.pointIds, this.pointNames)

      // 用作标题
      this.tabSystemList = [this.sensorDetailData.boxName]
      this.tabActive = this.tabSystemList.length > 0 ? this.tabSystemList[0] : this.tabActive
    },
    async getRightData() {
      // 监测时长
      this.rightData.monitorTimeLength =
        this.sensorDetailData.monitorTimeLength && this.sensorDetailData.monitorTimeLength !== 0
          ? `${this.sensorDetailData.monitorTimeLength}天`
          : this.rightData.monitorTimeLength
      // 剩余电量
      this.rightData.electricity =
        this.sensorDetailData.electricity && this.sensorDetailData.electricity !== 0
          ? this.sensorDetailData.electricity
          : this.rightData.electricity
      // 包含测点
      this.rightData.pointListLength = this.sensorDetailData.pointList
        ? this.sensorDetailData.pointList.length
        : this.rightData.pointListLength
      // 近30天预警次数(暂时移除)
      // this.rightData.alarmCount = await this.getAlarmData() || this.rightData.alarmCount
    },
    // 获取30天告警数据
    async getAlarmData() {
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
      const [err, res] = await wizboxListingApi.findBoxAlarmCountUsingGET(
        this.sensorDetailData.boxIdentifier,
        dayjs(thirtyDaysAgo).format('YYYY-MM-DD HH:mm:ss'),
        dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
      )
      if (!err) {
        return `${res.data}次`
      }
      return null
    },
    // 获取图表数据
    async getChartData(pointIds, pointNames) {
      // pointIds = ['9113', '16732'] // 测试测点id
      // pointNames = ['测点1', '测点2'] // 测试测点名称
      if (pointIds.length === 0) {
        return
      }
      this.getTimeStamp()
      const params = {
        maxResultCount: 500,
        skipCount: 0,
        ids: pointIds,
        startTimeStamp: this.startOfDayTimestamp,
        endTimeStamp: this.endOfDayTimestamp,
        interval: 3600, // 1小时
      }
      const [err, res] = await iotApi.getDivideValueListForMeasuringPoints({ body: params })
      if (!err) {
        // 解析响应数据并反转顺序
        const parseRes = JSON.parse(res.data).reverse()
        const graphData = {}
        const seriesArr = []
        // 遍历点ID数组，构造图表数据
        pointIds.forEach((pointId, index) => {
          graphData[`graphData${index + 1}`] = parseRes.map((scatterData) => {
            return [dayjs(scatterData.time * 1000).format('YYYY-MM-DD HH:mm'), scatterData[pointId]]
          })
        })
        // 获取图表数据的键值，并准备系列数据
        const graphDataArr = Object.keys(graphData)
        graphDataArr.forEach((ite, index) => {
          const processData = graphData[ite].map((item) => {
            return item[1]
          })
          seriesArr.push({
            titleSort: `${index + 1}`,
            type: 'line',
            name: pointNames[index],
            data: processData,
            symbolSize: 5,
            animation: true,
            itemStyle: {
              normal: {
                label: {
                  show: false, // 隐藏折线数据显示
                },
              },
            },
          })
        })
        // 设置图表选项中的图例和X轴数据
        this.detailOptions.legend.data = pointNames
        this.detailOptions.xAxis.data = graphData[graphDataArr[0]].map((item) => {
          return item[0]
        })
        // 设置图表的系列数据
        this.detailOptions.series = seriesArr
      }
    },
    // 获取当天的开始时间戳(00:00)和结束时间戳(当天当前时间)
    getTimeStamp() {
      const now = new Date()
      // 设置到当天的00:00
      const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      this.startOfDayTimestamp = Math.floor(startOfDay.getTime() / 1000)
      // 设置到当天的当前时间
      const endOfDay = new Date()
      this.endOfDayTimestamp = Math.floor(endOfDay.getTime() / 1000)
    },
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-diy {
  background-image: url('../../image/IntelligentPowerGenerationImg/smartTowTicketsBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
::v-deep .diy-input-style {
  .el-input__inner {
    text-overflow: ellipsis;
    cursor: default;
  }
}
</style>
